/****   http.js   ****/
// 导入封装好的axios实例
import request from './request'

const http = {
  /**
   * methods: 请求
   * @param url 请求地址
   * @param params 请求参数
   */
  get(url, params, isFile) {
    const config = {
      method: 'get',
      url: url,
    }
    if (params) config.params = params
    if (isFile) config.responseType = 'blob'
    return request(config)
  },
  post(url, params, isFile) {
    const config = {
      method: 'post',
      url: url,
    }
    if (params) config.data = params
    if (isFile) config.responseType = 'blob'
    return request(config)
  },
  put(url, params, isFile) {
    const config = {
      method: 'put',
      url: url,
    }
    if (params) config.params = params
    if (isFile) config.responseType = 'blob'
    return request(config)
  },
  delete(url, params, isFile) {
    const config = {
      method: 'delete',
      url: url,
    }
    if (params) config.params = params
    if (isFile) config.responseType = 'blob'
    return request(config)
  },
}
//导出
export default http
